<template>
    <TemplatesPage
        :title="$t('lang.group.keywords.title')"
        :loading="loading"
        :error-message="error"
        :info-message="info"
    >
        <DataTable
            v-if="tableData"
            :value="tableData.data"
            :rows="tableData.per_page"
            :totalRecords="tableData.total"
            paginatorPosition="both"
            :paginator="true"
            :paginatorTemplate="getPaginatorTemplate"
            scrollable
            :rowsPerPageOptions="getRowsPerPageOptions"
            lazy
            sortMode="multiple"
            :multiSortMeta="params.sort"
            v-model:selection="selected"
            @page="update"
            @sort="update"
        >
            <Column selectionMode="multiple"></Column>
            <Column field="word" :header="$t('lang.group.keywords.column_word')" sortable>
                <template #body="{ data, field }">
                    <div class="flex" @contextmenu="(event) => getContextMenu(event, data, field, ['matches'])">
<!--                    <div class="flex" @contextmenu="(event) => ">-->
<!--                    <div class="flex" @contextmenu="(event) => getContextMenu(event, data, data.word, ['similar', 'exclude', 'copy'])">-->
                        <Button
                            icon="pi pi-share-alt"
                            :title="$t('lang.group.keywords.title_icon_report', [data.word])"
                            text
                            size="small"
                            class="mr-1"
                            severity="secondary"
                            @click="onClickReport(data.word)"
                        />
                        <Button
                            icon="pi pi-file"
                            :title="$t('lang.group.keywords.title_icon_page', [data.word])"
                            text
                            size="small"
                            class="mr-1"
                            severity="secondary"
                            @click="onClickPage(data.word)"
                        />
                        <span>{{ data.word }}</span>
                    </div>
                </template>
            </Column>
            <Column field="weight" sortable>
                <template #header>
                    <span class="p-column-title" :title="$t('lang.group.keywords.column_weight_title')">{{ $t('lang.group.keywords.column_weight') }}</span>
                </template>
                <template #body="{ data, field }">
                    <span @contextmenu="(event) => getContextMenu(event, data, field, ['matches'])">{{ data.weight }}</span>
                </template>
            </Column>
            <Column field="ws" sortable>
                <template #header>
                    <span class="p-column-title" :title="$t('lang.group.keywords.column_ws_title')">{{ $t('lang.group.keywords.column_ws') }}</span>
                </template>
            </Column>
            <Column v-if="isYandex" field="wsk" sortable>
                <template #header>
                    <span class="p-column-title" :title="$t('lang.group.keywords.column_wsk_title')">{{ $t('lang.group.keywords.column_wsk') }}</span>
                </template>
            </Column>
            <Column field="numwords" sortable>
                <template #header>
                    <span class="p-column-title" :title="$t('lang.group.keywords.column_numwords_title')">{{ $t('lang.group.keywords.column_numwords') }}</span>
                </template>
            </Column>
            <Column>
                <template #body="{ data }">
                    <div class="flex column-gap-1" @contextmenu="test">
                        <Button
                            v-if="data.isquest"
                            icon="pi pi-question-circle"
                            :title="$t('lang.group.keywords.title_icon_question')"
                            text
                            size="small"
                            class="cursor-auto"
                            severity="secondary"
                        />
                        <Button
                            v-if="data.isgeo"
                            icon="pi pi-globe"
                            :title="$t('lang.group.keywords.title_icon_geo')"
                            text
                            size="small"
                            class="cursor-auto"
                            severity="secondary"
                        />
                    </div>
                </template>
            </Column>
        </DataTable>
        <TableActionsKeyword :reportRid="reportId" />
        <ContextMenu ref="contextMenu" :model="getContextMenuItems" />
    </TemplatesPage>
</template>

<script>
import TemplatesPage from "../../../templates/Page.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import GroupReportApi from "../../../api/GroupReportApi";
import {TableHelper} from "../../../helpers/TableHelper";
import AppMixin from "../../../mixins/AppMixin";
import BaseReport from "../../../component/table/BaseReport.vue";
import Button from "primevue/button";
import TableActionsKeyword from "../../../component/table/actions/keyword.vue";
import {isEmpty} from "lodash";
import {ArrayHelper} from "../../../helpers/ArrayHelper";
import ContextMenu from 'primevue/contextmenu';

export default {
    extends: BaseReport,
    name: "GroupKeywords",
    mixins: [AppMixin],
    props: {
        reportId: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            params: {
                sort: [],
                page: 1,
                per_page: TableHelper.getDefaultRowsPerPage(),
                filter: null
            },
        };
    },
    methods: {
        async loadData(params) {
            this.loading = true;
            this.tableData = await GroupReportApi.getReportKeywords(this.reportId, params);
            this.loading = false;
        },
        setDefaultParams() {
            this.params['sort'] = [
                {field: 'weight', order: -1},
                {field: this.isYandex ? 'wsk' : 'ws', order: -1},
            ];
        },
        onClickReport(key) {
            window.open(sprintf('/%s/similarkeys?key=%s', window.locale, key), '_self');
        },
        onClickPage(key) {
            window.open(sprintf('/%s/report?domain=%s', window.locale, key), '_self');
        },
        getDataForTableActions() {
            if (!this.selected || isEmpty(this.selected)) {
                return null;
            }

            return ArrayHelper.getUniqueAttrValuesOfObjectsByName(this.selected, 'id');
        },
    },
    components: {
        TemplatesPage,
        DataTable,
        Column,
        Button,
        TableActionsKeyword,
        ContextMenu,
    }
}
</script>
